import { create } from 'zustand'

interface DataConsentModalState {
  isOpen: boolean
  showModal: () => void
  hideModal: () => void
}

export const useDataConsentModal = create<DataConsentModalState>((set) => ({
  isOpen: false,
  showModal: () => set({ isOpen: true }),
  hideModal: () => set({ isOpen: false }),
}))
